export default __webpack_public_path__ + "assets/uruguay-flag.png";